export default __webpack_public_path__ + "static/media/psd.f5e5c261.svg";